if (typeof debounce === 'undefined') {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
/**
 *  @class
 *  @function ThemeHeader
 */
if (!customElements.get('theme-header')) {
  class ThemeHeader extends HTMLElement {
    constructor() {
      super();
      this.lastScrollTop = 0;
    }
    connectedCallback() {
      this.header_section = document.querySelector('.header-section');
      this.menu = this.querySelector('#mobile-menu');
      this.toggle = document.querySelector('.mobile-toggle-wrapper');

      document.addEventListener('keyup', (e) => {
        if (e.code) {
          if (e.code.toUpperCase() === 'ESCAPE') {
            this.toggle.removeAttribute('open');
            this.toggle.classList.remove('active');
          }
        }
      });
      this.toggle.querySelector('.mobile-toggle').addEventListener('click', (e) => {
        if (this.toggle.classList.contains('active')) {
          e.preventDefault();
          document.body.classList.remove('overflow-hidden');
          this.toggle.classList.remove('active');
          this.closeAnimation(this.toggle);
        } else {
          document.body.classList.add('overflow-hidden');
          setTimeout(() => {
            this.toggle.classList.add('active');
          });
        }
        window.dispatchEvent(new Event('resize.resize-select'));
      });

      // Sticky Header Class
      // window.addEventListener('scroll', this.setStickyClass.bind(this), {
      //   passive: true
      // });
      // Mobile Menu offset
      window.addEventListener('scroll', this.setHeaderOffset.bind(this), {
        passive: true
      });
      window.addEventListener('scroll', this.setHeaderHeight.bind(this), {
        passive: true
      });

      // window.addEventListener("scroll", this.handleScrollDirection.bind(this), {
      //   passive: true,
      // });

      window.dispatchEvent(new Event('scroll'));

      this.setAnnouncementHeight();
      const updateAnnouncement = () => this.setAnnouncementHeight();
      window.addEventListener('resize', updateAnnouncement, { passive: true });
      window.addEventListener('scroll', updateAnnouncement, { passive: true });

      // Watch for custom-announcement-bar appearing/changing dynamically (deferred render)
      // This prevents the layout shift when the bar renders after page load
      new MutationObserver(updateAnnouncement).observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'aria-hidden']
      });

      // Buttons.
      this.menu.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
      this.menu.querySelectorAll('.parent-link-back--button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
      
    }

    setStickyClass() {
      let announce = document.querySelector('.announcement-bar-section')
      let countdown = document.querySelector('.countdown-banner')
      if (this.classList.contains('header-sticky--active')) {
        let offset = parseInt(this.getBoundingClientRect().top, 10) + document.documentElement.scrollTop;
        if(announce){
        announce.classList.add('sticky')
        this.style.top='40px';
        offset = offset - 40;
        }
        if (countdown && announce){
          countdown.classList.add('countdown-sticky')
          this.style.top='126px';
          offset = offset - 126;
        }
        this.classList.toggle('is-sticky', window.scrollY >= offset && window.scrollY > 0);
      }
    }
    setAnnouncementHeight() {
      let h = 0;
      document.querySelectorAll('.announcement-bar-section, custom-announcement-bar').forEach((bar) => {
        if (bar.offsetHeight > 0) {
          h += bar.offsetHeight;
        }
      });
      document.documentElement.style.setProperty('--announcement-height', h + 'px');
    }
    setHeaderOffset() {
      let h = this.getBoundingClientRect().top;
      document.documentElement.style.setProperty('--header-offset', h + 'px');
    }
    setHeaderHeight() {
      let h = this.clientHeight;
      document.documentElement.style.setProperty('--header-height', h + 'px');
    }
    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const parentElement = summaryElement?.closest("ul");
      if(parentElement){
        const promotionEls = Array.from(parentElement.children)
          .filter(child => child.tagName === 'LI')
          .flatMap(li => Array.from(li.querySelectorAll(':scope > .mega-menu-promotion')));
        promotionEls.forEach(el => el.classList.add('is-hidden'));
      }
      const detailsElement = summaryElement.parentNode;
      const parentMenuElement = detailsElement.closest('.link-container');
      const isOpen = detailsElement.hasAttribute('open');

      if (this.querySelector('.parent-link-back--button')) {
        this.menu.scrollTop = 0;
      }

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
      }, 100);
    }
    onCloseButtonClick(event) {
      event.preventDefault();
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);

      const currentLI = event.currentTarget.closest("li");
      const currentUL = currentLI?.parentElement;
      const parentUL = currentUL?.parentElement.closest('ul');
      if(parentUL){
        const promotionEls = Array.from(parentUL.children)
        .filter(child => child.tagName === 'LI')
        .flatMap(li => Array.from(li.querySelectorAll(':scope > .mega-menu-promotion')));
        promotionEls.forEach(el => el.classList.remove('is-hidden'));  
      }  
    }
    closeSubmenu(detailsElement) {
      detailsElement.classList.remove('menu-opening');
      this.closeAnimation(detailsElement);
    }
    closeAnimation(detailsElement) {
      let animationStart;

      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
        }
      };

      window.requestAnimationFrame(handleAnimation);
    }
    handleScrollDirection() {
      const currentScroll = window.scrollY;
      if (currentScroll > this.lastScrollTop && currentScroll > 200) {
        this.classList.add("hide-on-scroll");
      } else {
        this.classList.remove("hide-on-scroll");
      }
      this.lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
    }
  }
  customElements.define('theme-header', ThemeHeader);
}
/**
 *  @class
 *  @function FullMenu
 */
if (!customElements.get('full-menu')) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.submenus = this.querySelectorAll('.thb-full-menu>.menu-item-has-children:not(.menu-item-has-megamenu)>.sub-menu');

      if (!this.submenus.length) {
        return;
      }
      const _this = this;
      // resize on initial load
      window.addEventListener('resize', debounce(function () {
        _this.resizeSubMenus();
      }, 100));

      window.dispatchEvent(new Event('resize'));

      document.fonts.ready.then(function () {
        _this.resizeSubMenus();
      });

    }
    resizeSubMenus() {
      this.submenus.forEach((submenu) => {
        let sub_submenus = submenu.querySelectorAll(':scope >.menu-item-has-children>.sub-menu');

        sub_submenus.forEach((sub_submenu) => {
          let w = sub_submenu.offsetWidth,
            l = sub_submenu.parentElement.parentElement.getBoundingClientRect().left + sub_submenu.parentElement.parentElement.clientWidth + 10,
            total = w + l;
          if (total > document.body.clientWidth) {
            sub_submenu.parentElement.classList.add('left-submenu');
          } else if (sub_submenu.parentElement.classList.contains('left-submenu')) {
            sub_submenu.parentElement.classList.remove('left-submenu');
          }
        });
      });
    }
  }
  customElements.define('full-menu', FullMenu);
}